import { api } from ".";

export async function fetchEvents() {
  const response = await api.get("/event");

  return response.data;
}